import script from "./ProcessReferralDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcessReferralDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ProcessReferralDialog.vue?vue&type=style&index=0&id=33b30b5e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b30b5e"]])

export default __exports__